import { useState, useRef, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import 'flag-icons/css/flag-icons.min.css'
import './LanguageSwitcher.css'

const KURDISTAN_FLAG_STYLE = {
    backgroundImage: 'url(/flag-kurdistan.svg)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
}

const LANGUAGES = [
    { code: 'en', flagCode: 'us', label: 'English' },
    { code: 'tr', flagCode: 'tr', label: 'Türkçe' },
    { code: 'de', flagCode: 'de', label: 'Deutsch' },
    { code: 'fr', flagCode: 'fr', label: 'Français' },
    { code: 'es', flagCode: 'es', label: 'Español' },
    { code: 'it', flagCode: 'it', label: 'Italiano' },
    { code: 'ms', flagCode: 'my', label: 'Bahasa Melayu' },
    { code: 'hi', flagCode: 'in', label: 'हिन्दी' },
    { code: 'ar', flagCode: 'sa', label: 'العربية' },
    { code: 'fa', flagCode: 'ir', label: 'فارسی' },
    { code: 'ur', flagCode: 'pk', label: 'اردو' },
    { code: 'ckb', flagCode: 'krd', label: 'کوردی سۆرانی' },
    { code: 'ku', flagCode: 'krd', label: 'Kurdî Kurmancî' },
]

export const LanguageSwitcher = ({ compact = false }) => {
    const { i18n } = useTranslation()
    const [open, setOpen] = useState(false)
    const dropdownRef = useRef(null)
    const detected = i18n.language.split('-')[0]
    const currentLanguage = LANGUAGES.find(language => language.code === detected)?.code ?? 'en'
    const current = LANGUAGES.find(language => language.code === currentLanguage)

    const handleSelect = (code) => {
        i18n.changeLanguage(code)
        setOpen(false)
    }

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpen(false)
            }
        }
        document.addEventListener('mousedown', handleClickOutside)
        return () => document.removeEventListener('mousedown', handleClickOutside)
    }, [])

    return (
        <div
            className={`language-switcher custom-dropdown${compact ? ' language-switcher--compact' : ''}`}
            ref={dropdownRef}>
            <button
                className='dropdown-toggle'
                aria-haspopup='listbox'
                aria-expanded={open}
                onClick={() => setOpen((prev) => !prev)}>
                <span
                    className={`fi fi-${current.flagCode} dropdown-flag`}
                    style={current.flagCode === 'krd' ? KURDISTAN_FLAG_STYLE : undefined} />
                <span className='dropdown-toggle-label'>{current.label}</span>
            </button>
            {open && (
                <ul className='dropdown-menu' role='listbox'>
                    {LANGUAGES.map((language) => (
                        <li
                            key={language.code}
                            className={`dropdown-option${language.code === currentLanguage ? ' selected' : ''}`}
                            role='option'
                            aria-selected={language.code === currentLanguage}
                            onClick={() => handleSelect(language.code)}>
                            <span
                                className={`fi fi-${language.flagCode} dropdown-flag`}
                                style={language.flagCode === 'krd' ? KURDISTAN_FLAG_STYLE : undefined} />
                            <span className='dropdown-label'>{language.label}</span>
                            {language.code === currentLanguage && <span className='dropdown-check'>✔️</span>}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    )
}
